import { isArrayNotEmpty } from '../../../../../../utils'

import { areLinkedCybusServiceEquals, Capability, type CybusLinkedService } from '../../../../../../domain'

import { BaseSubscriptionStrategy } from '../Base'

export class ServicesLinksStrategy extends BaseSubscriptionStrategy<'servicesLinks', never> {
    protected override readonly areEquals = areLinkedCybusServiceEquals

    override readonly requiredPermissions = [Capability.SERVICES_READ]

    override retrieveAll (): Promise<CybusLinkedService[]> {
        return this.request<'/api/services/all-links', 'GET', CybusLinkedService[]>({
            capability: Capability.SERVICES_READ,
            method: 'GET',
            path: '/api/services/all-links',
            queryParams: { onlyFromEnabledServices: 'true' },
            authenticate: true,
            handlers: {
                200: (response) =>
                    response
                        .getJson()
                        .then((data) =>
                            data.reduce<CybusLinkedService[]>(
                                (r, { id, name, links }) => (isArrayNotEmpty(links) ? [...r, { id, name, links: [...links] }] : r),
                                []
                            )
                        ),
            },
        })
    }
}
